import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { kPitchPaletteLength } from "@/shared/modal.api";
import type { ParameterRange } from "@/shared/parameter-range";
import { isObject } from "@/shared/utils/typeGuards";

export const kMagicFit25Route = "/magic-fit-2.5";

export { kPitchPaletteLength };

export const kVariationRange: ParameterRange = { min: 0, max: 1, default: 0.15 };
export const kBalanceRange: ParameterRange = { min: 0, max: 1, default: 0.5 };

export interface MagicFit25RequestBody {
    drivingAudioKey: string;
    timbreAudioKey: string;
    bpm: number;
    pitchPalette?: number[];
    variation?: number;
    balance?: number;
}

export const isMagicFit25RequestBody = (value: unknown): value is MagicFit25RequestBody =>
    isObject(value) &&
    typeof value.drivingAudioKey === "string" &&
    typeof value.timbreAudioKey === "string" &&
    typeof value.bpm === "number";

export const kMagicFit25Endpoint: ApiEndpoint<MagicFit25RequestBody, DownloadUrlResponse> = {
    route: kMagicFit25Route,
    label: "Magic Fit 2.5",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v2.5",
    description: "Magic Fit using the SpliceGen 2.5 model for finer-grained timbre control.",
    isRequestBody: isMagicFit25RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
